import React from 'react';

import AgDateFilterLayout from '@/components/AgGrid/components/AgDateFilter/AgDateFilterLayout';
import useAgDateFilterCore from '@/components/AgGrid/components/AgDateFilter/hooks/useAgDateFilterCore';
import { AgDateFilterProps } from '@/components/AgGrid/components/AgDateFilter/types';

const AgDateFilterBE: React.FC<AgDateFilterProps> = ({
  defaultOption,
  model,
  onModelChange,
  format,
  ownButtons,
  buttons,
}) => {
  const core = useAgDateFilterCore({ defaultOption, model, onModelChange });

  return <AgDateFilterLayout format={format} buttons={ownButtons ?? buttons ?? []} {...core} />;
};

export default AgDateFilterBE;
